import * as paymentType from './payment.json'

export default {
  [paymentType.P_KBANK_DEPOSIT]: require('@/assets/icon-bank/SVG/Kbank.svg'),
  [paymentType.P_KRUNGSRI_DEPOSIT]: require('@/assets/icon-bank/SVG/Krungsri.svg'),
  [paymentType.P_2C2P_DEPOSIT]: require('@/assets/icon-bank/SVG/Visa-MasterCard.svg'),
  [paymentType.P_KBANK_FULL]: require('@/assets/icon-bank/SVG/Visa-MasterCard.svg'),
  [paymentType.P_KRUNGSRI_FULL]: require('@/assets/icon-bank/SVG/Krungsri.svg'),
  [paymentType.P_2C2P_FULL]: require('@/assets/icon-bank/SVG/Visa-MasterCard.svg'),
  [paymentType.P_KBANK_INSTALLMENT]: require('@/assets/icon-bank/SVG/Kbank.svg'),
  [paymentType.P_KRUNGSRI_INSTALLMENT]: require('@/assets/icon-bank/SVG/Krungsri.svg'),
  [paymentType.P_2C2P_INSTALLMENT]: require('@/assets/icon-bank/SVG/Visa-MasterCard.svg'),
  [paymentType.P_2C2P_UOB_INSTALLMENT]: require('@/assets/icon-bank/SVG/UOB.svg'),
  [paymentType.P_KBANK_QR_FULL]: require('@/assets/icon-bank/SVG/thai-qr.svg'),
  [paymentType.P_KBANK_QR_DEPOSIT]: require('@/assets/icon-bank/SVG/thai-qr.svg'),
  [paymentType.P_KRUNGSRI_FIRST_CHOICE_INSTALLMENT]: require('@/assets/icon-bank/PNG/KFC_2.png'),
  [paymentType.P_2C2P_CITYBANK_INSTALLMENT]: require('@/assets/icon-bank/SVG/Citi.svg'),
  [paymentType.P_SCBEASY_FULL]: require('@/assets/icon-bank/PNG/scb-speedy-cash.png'),
  [paymentType.P_SCBEASY_CREDIT_FULL]: require('@/assets/icon-bank/PNG/scb-speedy-cash.png'),
  [paymentType.P_SCBEASY_DEPOSIT]: require('@/assets/icon-bank/PNG/scb-speedy-cash.png'),
  [paymentType.P_SCBEASY_CREDIT_DEPOSIT]: require('@/assets/icon-bank/PNG/scb-speedy-cash.png'),
  [paymentType.P_SCBEASY_INSTALLMENT]: require('@/assets/icon-bank/PNG/SCB-APP.png'),
  [paymentType.P_KTC_REDIRECT]: require('@/assets/icon-bank/PNG/KTC.png'),
  [paymentType.P_KTC_INSTALLMENT]: require('@/assets/icon-bank/PNG/KTC.png'),
  [paymentType.P_2C2P_QR_REDIRECT]: require('@/assets/icon-bank/SVG/thai-qr.svg'),
}
